import { isAdmin, useAccount } from '@entities/shared/account';
import { useMyPermissions } from '@entities/client/permission';

import {
  adminNavigationItems,
  clientNavigationItems,
  settingsNavigationItems,
} from '../config';
import { filterNavigationItems } from '../lib';

// Picks the navigation set by principal type (admin/tenant vs client — mutually
// exclusive, mirrors the router's user/admin buckets), then filters it down to
// what the current user is allowed to see. Reuses cached `accounts/me` and
// `permissions/my` queries — no extra request.
export const useNavigationItems = () => {
  const account = useAccount();
  const permissions = useMyPermissions();

  const granted = permissions.data ?? [];
  const navigationItems =
    account.data && isAdmin(account.data) ? adminNavigationItems : clientNavigationItems;

  return {
    items: filterNavigationItems(navigationItems, granted),
    settings: filterNavigationItems(settingsNavigationItems, granted),
  };
};
